<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList" :actions="actions" :showSearch="false"
      :showHorizontalFilter="false" :propsParam="propsParam">
      <div slot="content-buttons">
        <Button _key="btnCollaboratorPriceTableCreate" title="Preço" classIcon="fas fa-plus-circle" type="primary"
          size="small" :clicked="create" />
      </div>
    </ViewTemplateConfiguration>
    <Modal title="Preço" :width="700" :height="600" v-show="showModal('collaboratorPriceTableCreateUpdate')">
      <CollaboratorPriceTableCreateUpdate :collaboratorId="collaboratorId" />
    </Modal>
  </div>
</template>

<script>
import ViewTemplateConfiguration from "@/ui/template/ViewTemplateConfiguration";
import Modal from "@/ui/forms/Modal";
import Button from "@/ui/forms/Button";

import CollaboratorPriceTableCreateUpdate from "./CollaboratorPriceTableCreateUpdate.vue";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CollaboratorPriceTableList",
  components: {
    ViewTemplateConfiguration,
    Modal,
    Button,
    CollaboratorPriceTableCreateUpdate,
  },
  props: {
    collaboratorId: String,
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/human-resources/collaborator-price-table/get-all",
        urlDeleteAllApi: "/api/v1/human-resources/collaborator-price-table/delete",
        headerTable: [
          {
            field: "typePriceName",
            title: "Período",
            type: "link",
            eventName: "updateCollaboratorPriceTable",
          },
          {
            field: "value",
            title: "R$ Valor",
            type: "currency",
            classCssTitle: "text-center",
            classCssBody: "text-center primary",
          },
        ],
      },
      actions: [
        {
          type: "delete",
          title: "Remover",
          description: "Remover",
          url: "/api/v1/human-resources/collaborator-price-table/delete",
          method: "delete",
        },
      ],
      propsParam: {
        any: this.collaboratorId,
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    create() {
      this.openModal("collaboratorPriceTableCreateUpdate");
      this.addEvent({ name: "collaboratorPriceTableCreate" });
      this.removeLoading(["btnCollaboratorPriceTableCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "updateCollaboratorPriceTable") this.openModal("collaboratorPriceTableCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
